const readonlyStates = ['compiled', 'sent', 'cleared', 'canceled', 'rejected', 'declined']

export function isEditableState(state) {
    return readonlyStates.includes(state)
}
